import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import NavbarComp from "../../shared/components/Navbar";
import { IoAddCircleOutline } from "react-icons/io5";
import Swal from "sweetalert2";
import { useAuth } from "../auth/hooks/useAuth";
import { useBanner } from "./hooks/useBanner";
import BannerTable from "./components/BannerTable";
import BannerModalAdd from "./components/BannerModalAdd";

const BannerPage = () => {
  const { validate } = useAuth();

  const [user, setUser] = useState();

  const [editingData, setEditingData] = useState(null);

  const {
    loading,
    error,
    banner,
    meta,
    addBanner,
    editBanner,
    fetchBannerById,
    fetchBanner,
    removeBanner,
    updateOnActive,
  } = useBanner();

  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleEditProduct = (product) => {
    // setEditingData(product)
    handleOpenModal(product);
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        removeBanner(id.id); // Call delete function if confirmed
        Swal.fire("Deleted!", "The item has been deleted.", "success");
      }
    });
  };

  const addCategoriesDetail = (data) => {
    addBanner(data);
  };

  useEffect(() => {
    // (async () => {
    //     const userData = await validate();
    //     setUser(userData);
    // })();
  }, [validate, banner]);

  const handleEdit = (data) => {
    setEditingData(data);
    handleOpenModal(data);
  };

  return (
    <>
      <NavbarComp />
      <Container fluid className="mt-2 mt-md-5">
        <Button
          Tooltip={"test"}
          variant="outline-success"
          className="mb-2"
          onClick={handleOpenModal}
        >
          <IoAddCircleOutline size={32} />
        </Button>
        <BannerTable
          banner={banner}
          meta={meta}
          fetchBanner={fetchBanner}
          loading={loading}
          onEdit={handleEdit}
          onDelete={handleDelete}
          updateOnActive={updateOnActive}
        />
      </Container>

      <BannerModalAdd
        show={showModal}
        handleClose={handleCloseModal}
        handleAddBanner={addBanner}
        parsingDataEdit={editingData}
        editBanner={editBanner}
      />
    </>
  );
};

export default BannerPage;
